export default '/build/46150e10.svg'